import { render, staticRenderFns } from "./testDialog.vue?vue&type=template&id=90bb3934&scoped=true"
import script from "./testDialog.vue?vue&type=script&lang=js"
export * from "./testDialog.vue?vue&type=script&lang=js"
import style0 from "./testDialog.vue?vue&type=style&index=0&id=90bb3934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bb3934",
  null
  
)

export default component.exports